import { lazy, Suspense } from 'react';

const SearchInput = lazy(() => import('./SearchInput').then((module) => ({ default: module.SearchInput })));

export const SearchInputLazy = () => {
  return (
    <Suspense fallback={null}>
      <SearchInput />
    </Suspense>
  );
};
